@if (currentSinistre && (user|hasRight:'admin')) {

  <p-drawer [(visible)]="colRight2IsActive" position="right" styleClass="!w-full md:!w-[40rem]">
    <div class="flex flex-col h-full">

      <!-- En-tête : titre + référence + récap rapide -->
      <div class="px-2 pt-2 pb-3 border-b border-gray-200">
        <div class="flex items-center justify-between gap-2 flex-wrap">
          <div>
            <h3 class="text-xl tracking-tight font-semibold text-gray-900 flex items-center gap-2">
              <i class="fa-light fa-triangle-exclamation text-amber-500"></i>
              {{ 'Anomalies du sinistre' | transloco }}
            </h3>
            <div class="text-sm text-gray-500 mt-0.5">
              {{ currentSinistre?.referencevge }}
              @if (currentSinistre | chronoRef) { <span class="text-xs text-gray-500 ml-1">({{ currentSinistre | chronoRef }})</span> }
            </div>
          </div>

          <!-- Récap par sévérité -->
          @if (nbAnomalies > 0) {
            <div class="flex items-center gap-1.5 flex-wrap">
              @if (nbDanger > 0) {
                <span class="inline-flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-full bg-red-50 text-red-700 border border-red-200">
                  <i class="fa-light fa-circle-exclamation"></i> {{ nbDanger }} {{ 'critique' | transloco }}
                </span>
              }
              @if (nbWarning > 0) {
                <span class="inline-flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-full bg-amber-50 text-amber-700 border border-amber-200">
                  <i class="fa-light fa-triangle-exclamation"></i> {{ nbWarning }} {{ 'attention' | transloco }}
                </span>
              }
              @if (nbInfo > 0) {
                <span class="inline-flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-full bg-sky-50 text-sky-700 border border-sky-200">
                  <i class="fa-light fa-circle-info"></i> {{ nbInfo }} {{ 'info' | transloco }}
                </span>
              }
            </div>
          } @else {
            <span class="inline-flex items-center gap-1.5 text-xs font-semibold px-2 py-1 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200">
              <i class="fa-light fa-circle-check"></i> {{ 'Aucune anomalie' | transloco }}
            </span>
          }
        </div>
      </div>

      <!-- Corps : liste des anomalies (causes unifiées) -->
      <div class="flex-1 overflow-y-auto px-2 py-3 space-y-2">

        @if (nbAnomalies === 0) {
          <div class="flex flex-col items-center justify-center py-12 text-center">
            <div class="w-16 h-16 rounded-full bg-emerald-50 flex items-center justify-center mb-3">
              <i class="fa-light fa-shield-check text-3xl text-emerald-500"></i>
            </div>
            <p class="text-base font-semibold text-gray-700">{{ 'Dossier sain' | transloco }}</p>
            <p class="text-sm text-gray-500 mt-1">{{ 'Aucune anomalie détectée sur ce sinistre.' | transloco }}</p>
          </div>
        }

        @for (cause of causes; track cause.code) {
          @let badge = causeBadgeMap[cause.code] || {icon: 'fa-light fa-triangle-exclamation', classes: 'text-gray-700 bg-gray-50 border-gray-200'};
          @let chip = severityChip[cause.severity] || severityChip.warning;

          <div class="flex items-start gap-3 rounded-xl border p-3 transition-all hover:shadow-sm"
               [ngClass]="badge.classes">

            <!-- Icône -->
            <div class="shrink-0 w-10 h-10 rounded-lg flex items-center justify-center bg-white/60 border border-current/20">
              <i [ngClass]="badge.icon" class="text-xl"></i>
            </div>

            <!-- Contenu -->
            <div class="flex-1 min-w-0">
              <div class="flex items-center justify-between gap-2 flex-wrap">
                <h5 class="text-sm font-semibold leading-tight flex items-center gap-1.5">
                  @if (cause.blockLeave) {
                    <i class="fa-light fa-lock text-red-600"
                       [pTooltip]="'Bloque la sortie de la fiche tant que non résolu' | transloco"></i>
                  }
                  {{ cause.label | transloco }}
                </h5>
                <span class="inline-block text-[10px] font-bold uppercase tracking-wide px-1.5 py-0.5 rounded"
                      [ngClass]="chip.classes">
                  {{ chip.label | transloco }}
                </span>
              </div>
              @if (cause.detail) {
                <p class="text-xs mt-1 opacity-90" [innerHTML]="cause.detail"></p>
              }
              <div class="flex items-center gap-2 mt-1.5 text-[10px] uppercase tracking-wider opacity-60">
                @if (cause.category) {
                  <span><i class="fa-light fa-tag mr-1"></i>{{ cause.category | transloco }}</span>
                }
                @if (cause.blockLeave) {
                  <span class="text-red-700 font-semibold">
                    <i class="fa-light fa-lock mr-1"></i>{{ 'Sortie bloquée' | transloco }}
                  </span>
                }
              </div>
            </div>
          </div>
        }

      </div>

      <!-- Pied : lien vers la page anomalies globale (admin) -->
      <div class="px-3 py-2 border-t border-gray-200 bg-gray-50 text-xs text-gray-500">
        <i class="fa-light fa-info-circle mr-1"></i>
        {{ 'Les anomalies sont calculées en temps réel à partir des données du sinistre. Pour la vue globale par client, voir' | transloco }}
        <a class="text-cyan-700 hover:underline" [routerLink]="['/DOnet/DOstat/anomalies']" (click)="toggleSidebar2()">DOstat → Anomalies</a>.
      </div>
    </div>
  </p-drawer>


  <!-- Poignée latérale (handle) : badge dynamique selon sévérité max -->
  <div
    id="colDO"
    #colRight2
    class="fixed right-0 top-2/3 z-40 transform transition-all -translate-y-1/2 cursor-pointer group"
    [ngClass]="{'-translate-[40rem] z-[1102]': colRight2IsActive}"
    (click)="toggleSidebar2()"
  >
    <div class="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-l-lg shadow-lg hover:shadow-xl transition-all duration-300 group-hover:scale-105">
      <div class="relative px-2 py-4 min-h-[120px] flex flex-col space-y-2 items-center justify-center gap-3">

        <div class="flex flex-col items-center gap-1">
          <div class="writing-mode-vertical text-xs font-medium text-gray-600 dark:text-gray-300">
            {{ 'Anomalies' | transloco }} {{ currentSinistre?.referencevge }}
          </div>
          <div
            class="relative mt-2 inline-flex items-center justify-center min-w-[24px] h-6 px-2 text-xs font-bold text-white rounded-full shadow-sm rotate-90"
            [ngClass]="handleBadgeClasses()"
            [pTooltip]="handleTooltip()"
            placement="left"
          >
            @if (nbAnomalies > 0) {
              {{ nbAnomalies }}
            } @else {
              <i class="fa-light fa-check"></i>
            }
          </div>
        </div>

        <div>
          <i class="fa-light fa-chevron-left text-gray-400 dark:text-gray-500 text-sm group-hover:text-gray-600 dark:group-hover:text-gray-300 transition-colors duration-200"
             [class.rotate-180]="colRight2IsActive"></i>
        </div>
      </div>
    </div>
  </div>

}


<style>
  .writing-mode-vertical {
    writing-mode: vertical-rl;
    text-orientation: mixed;
  }
</style>
